import React from "react";

/**
 * Informational strip of the outside systems a page can connect to: a plain brand
 * mark where one is available, a neat name tile otherwise.
 */
export default function ToolLogoStrip({ tools, title, compact = false }) {
  return (
    <div className={`border rounded bg-light px-3 ${compact ? "py-2" : "py-3"} mb-3`}>
      <div className="extra-small fw-bold text-uppercase text-muted mb-2" style={{ letterSpacing: "0.5px" }}>
        {title}
      </div>
      <div className="d-flex flex-wrap align-items-center gap-2">
        {tools.map((t) => (
          <span
            key={t.code}
            title={t.name}
            className="d-inline-flex align-items-center gap-1 bg-white border rounded px-2"
            style={{ height: compact ? 28 : 34 }}
          >
            {t.logo && <img src={t.logo} alt="" style={{ height: compact ? 14 : 18, width: "auto", opacity: 0.8 }} />}
            <span className="small fw-bold text-secondary">{t.name}</span>
          </span>
        ))}
      </div>
      {!compact && (
        <div className="extra-small text-muted mt-2">Names and logos belong to their owners and are shown for information only.</div>
      )}
    </div>
  );
}
